import { z } from 'zod';
export const FlowInitiatorConfigSchema = z.object({
    flowId: z.uuid(),
    organizationId: z.uuid(),
    maxFlowRunsPerMinute: z.coerce.number().positive().nullable().optional(),
    allowUnpublishedFlowRuns: z.coerce.boolean().nullable().optional(),
    desiredFlowRunPriority: z.coerce.number().nullable().optional(),
});
//# sourceMappingURL=initiator.js.map